// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1O6gA","choiceBoxes":"toolbarselects_choiceBoxes__1G0XN","simpleField":"toolbarselects_simpleField__EWDV8"};